import React from "react";

const DeleteModal = ({ onClose, onConfirm, name }) => {
  return (
    <>
      <div className="modal_private_pay">
        <div className="modal-content_private_pay">
          <span className="close_private_pay" onClick={onClose}>
            ×
          </span>
          <div
            style={{
              textAlign: "left",
              fontSize: "27px",
              fontWeight: "bold",
            }}
          >
           Ennhealth
          </div>
          <div style={{ textAlign: "left", fontSize: "17px", fontWeight: "" }}>
            Are you sure you want to delete this {name}?
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginTop: 16,
            }}
          >
            <button className="btn-secondary_private_pay" onClick={onClose}>
              No
            </button>
            <button className="add-button_private_pay" onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
